module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/d3XzQd/images/9781439678008.jpg?1737821500087",
      "alt": "This image is the cover for the book Ghostly Tales of Columbia, Spooky America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostly Tales of Columbia, Spooky America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from America's heartland have never been so creepy, fun, and full of mystery! "), _c('br'), _vm._v(" Welcome to the spooky streets of Columbia, Missouri! "), _c('br'), _vm._v(" Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. "), _c('br'), _vm._v(" Did you know ghostly soldiers reenact Civil War battles along one road in Woodlandville? Or that a demon pack of hunting dogs can still be heard baying on a haunted farm outside Columbia? Can you believe that in the home of the University president, a former resident decided never to leave? "), _c('br'), _vm._v(" Pulled right from history, these ghostly tales will change the way you see Columbia and have you sleeping with the light on!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen Emily Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KAREN EMILY MILLER  has been writing about strange creatures since she was six years old, so writing about the paranormal is a perfect fit. She just moved to Iowa City and is excited to meet new ghosts there.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0